export default __webpack_public_path__ + "static/media/img_baseBunnyCrochet_rose.655670b6.jpg";